import React, { useEffect, useState } from "react";

function Title({ title }) {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div
      style={{
        margin: "auto",
        marginTop: 47,
        marginBottom: 10,
        width:
          size.width >= 1000
            ? 784
            : size.width > 375
            ? size.width > 320
              ? "87%"
              : "77%"
            : "85%",
      }}
    >
      <div class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px">
        {title}
      </div>
    </div>
  );
}

export default Title;
